/*
 * Just like topicsControls: a weird name, but it's just a module for controls for a content list
 */

define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/contentsSplit/contents/contentsList/contentsControls/contentsControlsView",
  "modules/shared/moveModal/moveModalModule",
  "modules/contentsSplit/content/contentModel",
], function (Marionette, $, Messenger, ContentsControlsView, MoveModalModule, ContentModel) {
  var ContentsControlsController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "contentsControls";
      this.region = options.region;
    },
    show: function (group, rootContentGroup) {
      this.view = new ContentsControlsView.contentsControlsView({ model: group });
      if (group.isNew() && group.get("groupName").length === 0) {
        //auto-select group name textbox if the group is new
        this.view.on(
          "show",
          function () {
            this.view.enableTextbox("#contentFolderText");
          },
          this,
        );
      }
      //show error message if the content is found to be invalid
      group.on(
        "invalid",
        function (model, error) {
          this.nameError(error["groupName"]);
        },
        this,
      );

      //delete all the contents that are selected
      this.view.on(
        "delete:contents",
        function () {
          //clear any old errors
          this.clearError();
          //get the checked models from the sortable list (with namespace)
          var contentsToDelete = Messenger.reqres.request("contentsList:checked:models");
          if (contentsToDelete.length > 0) {
            Messenger.yesNoDialog(
              "contents.dialog.deleteContents",
              {
                yes: function () {
                  const contentsToDeleteLength = contentsToDelete.length;
                  const mappingIds = [];
                  for (let i = 0; i < contentsToDeleteLength; i++) {
                    Messenger.vent.trigger("track:interaction", {
                      action: "Delete Content",
                      id: contentsToDelete[i].id,
                      idType: "Content",
                      object: "Content",
                    });
                    mappingIds.push(contentsToDelete[i].id);
                  }
                  const batchDeleteModel = new ContentModel.batchDelete({
                    mappingIds: mappingIds,
                  });
                  batchDeleteModel.saveModel().then((success) => {
                    if (success) {
                      for (let i = 0; i < contentsToDeleteLength; i++) {
                        contentsToDelete[i].trigger("destroy", contentsToDelete[i]);
                      }
                    }
                  });
                },
              },
              this,
            );
          } else {
            this.controlsError($.t("contents.controls.emptyDelete"));
          }
        },
        this,
      );
      //move all the contents that are selected
      this.view.on(
        "move:contents",
        function () {
          //clear any old errors
          this.clearError();
          //get the checked models from the sortable list (with namespace)
          var contentsToMove = Messenger.reqres.request("contentsList:checked:models");
          if (contentsToMove.length > 0) {
            Messenger.save(function (success) {
              //save before attempting the move
              if (success) {
                Messenger.vent.trigger(
                  "show:modal",
                  MoveModalModule,
                  {},
                  {
                    modelsToMove: contentsToMove,
                    rootGroup: rootContentGroup,
                    nameAttribute: "groupName",
                    group: group,
                  },
                  {
                    title: $.t("contents.move.title"),
                    modalWidth: 400,
                    trackInteraction: {
                      action: "Move Contents to Group",
                      object: "Content",
                    },
                  },
                );
              }
            }, this);
          } else {
            this.controlsError($.t("contents.controls.emptyMove"));
          }
        },
        this,
      );

      //Begin Content Awareness

      this.view.on(
        "all:content:folder",
        function () {
          //reset to the primary view
          Messenger.vent.trigger("contents:select:standard");
        },
        this,
      );

      this.view.on(
        "modified:content:folder",
        function () {
          Messenger.vent.trigger("contents:select:modified");
        },
        this,
      );

      this.view.on(
        "missing:content:folder",
        function () {
          Messenger.vent.trigger("contents:select:missing");
        },
        this,
      );

      this.view.on(
        "ignored:content:folder",
        function () {
          Messenger.vent.trigger("contents:select:ignored");
        },
        this,
      );

      //End Content Awareness

      //add sub folder to the current folder
      this.view.on(
        "add:folder",
        function () {
          if (Messenger.reqres.request("save:textbox")) {
            //this check is not sufficient.  We needs to also check if the topic group is valid
            if (group.isValid()) {
              console.log("add folder");
              //need to get sub groups from the server first
              if (group.get("hasSubgroups")) {
                group.trigger("expand"); //expand group and load/show any subgroups
                //once the subGroups are synced, add a new group
                group.subGroups().onSynced(function () {
                  console.log("select group");
                  var newGroup = group.addSubGroup();
                  newGroup.trigger("select"); //select the new group for editing
                }, this);
              } else {
                var newGroup = group.addSubGroup();
                group.trigger("expand");
                newGroup.trigger("select");
              }
            }
          }
        },
        this,
      );
      //move folder
      this.view.on(
        "move:folder",
        function () {
          if (Messenger.reqres.request("save:textbox")) {
            if (group.isValid()) {
              console.log("move folder");
              //remove the folder from the collection, and show the move modal
              group.parent = group.collection.parent; //save parent just in case we need to cancel move
              group.collection.remove(group);
              Messenger.vent.trigger(
                "show:modal",
                MoveModalModule,
                {},
                {
                  rootGroup: rootContentGroup,
                  nameAttribute: "groupName",
                  group: group,
                },
                {
                  title: $.t("contents.moveFolder.title"),
                  modalWidth: 400,
                  trackInteraction: {
                    action: "Move Content Folder",
                    object: "Content Folder",
                  },
                },
              );
            }
          }
        },
        this,
      );
      //delete current folder
      this.view.on(
        "delete:folder",
        function () {
          console.log("delete folder");
          group.contents().onSynced(function () {
            if (group.contents().length === 0 && !group.get("hasSubgroups")) {
              Messenger.yesNoDialog(
                "contents.dialog.deleteFolder",
                {
                  yes: function () {
                    Messenger.vent.trigger("track:interaction", {
                      action: "Delete Content Folder",
                      id: group.id,
                      idType: "Content Folder",
                      object: "Content Folder",
                    });
                    var parentModel = group.collection.parent;
                    Messenger.vent.trigger("cancel:textbox"); //cancel any open textboxes
                    group.deleteModel();
                    //switch to parent folder
                    parentModel.trigger("select");
                  },
                },
                this,
              );
            } else {
              Messenger.okDialog("contents.dialog.nonEmptyFolder");
            }
          }, this);
        },
        this,
      );

      this.showRegion(this.view);
    },
    clearError: function () {
      this.view.clearControlsError();
    },
    controlsError: function (errorMessage) {
      this.view.controlsError(errorMessage);
    },
    nameError: function (errorMessage) {
      this.view.nameError(errorMessage);
    },
  });

  return ContentsControlsController;
});
